import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import colors from "core/resources/theme/colors";
import { FiPackage } from "react-icons/fi";
import { SimpleGrid } from "@chakra-ui/layout";
import { useDashboardEncomenda } from "core/features/encomenda/hooks/useDashboardEncomenda";
import { FiltroEncomenda } from "../ListaEncomendaTable/hooks/useFiltroEncomenda";
import { Image } from "@chakra-ui/react";
import packageclosed from "assets/images/svgs/package-closed.svg";
import packageremove from "assets/images/svgs/package-remove.svg";
import { EncomendaStatusEnum } from "core/features/encomenda/typings";
import { isEqual } from "lodash";

interface DashboardEncomendaProps {
  filtro: FiltroEncomenda;
  onChangeFiltro?: (filtro: Partial<FiltroEncomenda>) => any;
}

function DashboardEncomenda({
  filtro,
  onChangeFiltro,
}: DashboardEncomendaProps) {
  const { data, isLoading: loading } = useDashboardEncomenda({
    ...filtro,
  });

  const isSelectedCardRecebidoPortaria = () => {
    return isEqual(filtro.statusId, EncomendaStatusEnum.RecebidaNaPortaria);
  };

  const isSelectedCardRecebidoSalaDeEncomendas = () => {
    return isEqual(
      filtro.statusId,
      EncomendaStatusEnum.RecebidaNaSalaDeEncomendas
    );
  };

  const isSelectedCardAguardando = () => {
    return isEqual(filtro.statusId, EncomendaStatusEnum.AguardandoRecebimento);
  };

  const isSelectedCardEntregue = () => {
    return isEqual(filtro.statusId, [
      EncomendaStatusEnum.EntregueAoMorador,
      EncomendaStatusEnum.EntregaConfirmadaPeloMorador,
    ]);
  };

  return (
    <SimpleGrid
      columns={{ sm: 1, md: 1, lg: 3, xl: 4 }}
      gap="16px"
      mb="32px"
      mt="40px"
    >
      <Card1Horizontal
        icon={<FiPackage fontSize="24px" color={colors.blue300} />}
        color={colors.orange}
        bg={colors.blue200}
        description="Recebido na portaria"
        onClick={() =>
          onChangeFiltro?.({
            statusId: EncomendaStatusEnum.RecebidaNaPortaria,
          })
        }
        selected={isSelectedCardRecebidoPortaria()}
        title={`${data?.recebidoPortaria ?? 0}`}
        loading={loading}
      />

      <Card1Horizontal
        icon={<FiPackage fontSize="24px" color={colors.blue300} />}
        color={colors.orange}
        bg={colors.blue200}
        description="Recebido na sala de encomendas"
        onClick={() =>
          onChangeFiltro?.({
            statusId: EncomendaStatusEnum.RecebidaNaSalaDeEncomendas,
          })
        }
        selected={isSelectedCardRecebidoSalaDeEncomendas()}
        title={`${data?.recebidoSalaDeEncomendas ?? 0}`}
        loading={loading}
      />

      <Card1Horizontal
        icon={<Image src={packageremove} w="100%" h="25px" />}
        color={colors.green}
        bg={colors.orange50}
        description="Aguardando entrega"
        onClick={() =>
          onChangeFiltro?.({
            statusId: EncomendaStatusEnum.AguardandoRecebimento,
          })
        }
        selected={isSelectedCardAguardando()}
        title={`${data?.aguardandoRecebimento}`}
        loading={loading}
      />

      <Card1Horizontal
        icon={<Image src={packageclosed} w="100%" h="25px" />}
        color={colors.blue}
        bg={colors.green100}
        description={data?.entregue === 1 ? "Entregue" : "Entregues"}
        onClick={() =>
          onChangeFiltro?.({
            statusId: [
              EncomendaStatusEnum.EntregueAoMorador,
              EncomendaStatusEnum.EntregaConfirmadaPeloMorador,
            ],
          })
        }
        selected={isSelectedCardEntregue()}
        title={`${data?.entregue}`}
        loading={loading}
      />
    </SimpleGrid>
  );
}

export default DashboardEncomenda;
